module.exports = __webpack_public_path__ + "img/map_beneden-border.071a7739.png";